import { Images } from 'lucide-react';
import { Vignette } from './ChoixPhotosDialog';

// Aperçu des photos d'une partie : null/undefined = photos d'origine, [] = aucune
export const PhotosPartie = ({ ids, nbDefaut, onChoisir, testId }) => (
  <div className="mb-3 flex flex-wrap items-center gap-2" data-testid={testId}>
    {ids?.length > 0 && ids.map((id) => <Vignette key={id} id={id} className="h-14 w-20 rounded-md" />)}
    {ids == null && <span className="text-xs text-slate-500">{nbDefaut ? `${nbDefaut} photo${nbDefaut > 1 ? 's' : ''} d'origine` : 'Sans photo'}</span>}
    {ids?.length === 0 && <span className="text-xs text-slate-500">Aucune photo</span>}
    <button type="button" onClick={onChoisir} data-testid={`${testId}-choisir`}
      className="inline-flex items-center gap-1 rounded-full border border-slate-200 px-3 py-1 text-xs font-medium text-slate-600 transition-colors hover:border-[#8DC63F] hover:text-[#0F172A]">
      <Images className="h-3.5 w-3.5" /> Choisir mes photos
    </button>
  </div>
);
